(function () {
  'use strict';

  let thumbnailSwiper = null;
  let mainSwiper = null;
  let rubbitInActionSwiper = null;

  function initGallery() {
    console.debug(initGallery, "initGallery");
    if (typeof Swiper === 'undefined') {
      setTimeout(initGallery, 100);
      return;
    }

    const container = document.querySelector('.new-product-block');
    if (!container) return;

    const isDesktop = window.innerWidth >= 990;

    const thumbnailEl = container.querySelector('.new-product-block__thumbnails-swiper');
    const mainDesktopEl = container.querySelector('.new-product-block__main-image-swiper-desktop');
    const mainMobileEl = container.querySelector('.new-product-block__main-image-swiper');
    const rubbitInActionEl = container.querySelector('.rubbit-in-action-slider');
    const rubbitPrevEl = container.querySelector('.rubbit-in-action-prev');
    const rubbitNextEl = container.querySelector('.rubbit-in-action-next');
    
    // --- DESTROY EXISTING ---
    if (thumbnailSwiper) {
      thumbnailSwiper.destroy(true, true);
      thumbnailSwiper = null;
    }

    if (mainSwiper) {
      mainSwiper.destroy(true, true);
      mainSwiper = null;
    }

    if (rubbitInActionSwiper) {
      rubbitInActionSwiper.destroy(true, true);
      rubbitInActionSwiper = null;
    }
   
    // --- DESKTOP ---
    if (isDesktop) {
      
      // Thumbnails swiper (desktop)
      if (thumbnailEl) {
        const thumbPrevEl = container.querySelector('.new-product-block__thumb-nav--up');
        const thumbNextEl = container.querySelector('.new-product-block__thumb-nav--down');
        const thumbSlidesCount = thumbnailEl.querySelectorAll('.swiper-slide').length;
        const shouldShowThumbNav = thumbSlidesCount > 5;
        
        if (thumbPrevEl) thumbPrevEl.style.display = shouldShowThumbNav ? '' : 'none';
        if (thumbNextEl) thumbNextEl.style.display = shouldShowThumbNav ? '' : 'none';
    
        thumbnailSwiper = new Swiper(thumbnailEl, {
          direction: 'vertical',
          slidesPerView: 5,
          spaceBetween: 10,
          watchSlidesProgress: true,
          watchOverflow: true,
          navigation: {
            prevEl: thumbPrevEl,
            nextEl: thumbNextEl,
          }
        });
        console.debug(thumbnailSwiper, "thumbnailSwiper");
      }

      // Main desktop swiper
      if (mainDesktopEl) {
        const mainSlidesCount = mainDesktopEl.querySelectorAll('.swiper-slide').length;
        const shouldShowMainNav = mainSlidesCount > 5;


        mainSwiper = new Swiper(mainDesktopEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          thumbs: thumbnailSwiper ? { swiper: thumbnailSwiper } : undefined,
        });
      }

      // Active state syncing (no repetition)
      const thumbnails = container.querySelectorAll('.new-product-block__thumbnail');

      thumbnails.forEach((thumb, index) => {
        if (thumb.dataset.rubbitThumbBound === '1') return;
        thumb.dataset.rubbitThumbBound = '1';

        thumb.addEventListener('click', () => {
          if (mainSwiper) {
            mainSwiper.slideTo(index);
          }
        });
      });

      if (mainSwiper) {
        mainSwiper.on('slideChange', () => {
          thumbnails.forEach(t => t.classList.remove('active'));
          thumbnails[mainSwiper.activeIndex]?.classList.add('active');
        });
      }
    }

    // --- MOBILE ---
    else {
      if (mainMobileEl) {
        const mobilePrevEl = container.querySelector('.new-product-block__mobile-nav--prev');
        const mobileNextEl = container.querySelector('.new-product-block__mobile-nav--next');
        const mobileSlidesCount = mainMobileEl.querySelectorAll('.swiper-slide').length;
        const shouldShowMobileNav = mobileSlidesCount > 5;
        const paginationEl = container.querySelector('.new-product-block__pagination');

        if (mobilePrevEl) mobilePrevEl.style.display = shouldShowMobileNav ? '' : 'none';
        if (mobileNextEl) mobileNextEl.style.display = shouldShowMobileNav ? '' : 'none';
        
        mainSwiper = new Swiper(mainMobileEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            el: paginationEl,
            clickable: true,
          },
        });
      }
    }
   
    // --- RUBBIT IN ACTION (Desktop + Mobile) ---
    if (rubbitInActionEl) {
      const rubbitSlidesCount = rubbitInActionEl.querySelectorAll('.swiper-slide').length;
      const rubbitNav = container.querySelector('.rubbit-in-action-nav');

      // Apply slider behavior only when more than 2 items exist.
      if (rubbitSlidesCount > 2) {
        // Show arrows only when slider mode is active.
        if (rubbitNav) rubbitNav.style.display = '';
        if (rubbitPrevEl) rubbitPrevEl.style.display = '';
        if (rubbitNextEl) rubbitNextEl.style.display = '';
        rubbitInActionEl.classList.remove('rubbit-in-action-slider--static');
        rubbitInActionSwiper = new Swiper(rubbitInActionEl, {
          slidesPerView: 2.3,
          spaceBetween: 8,
          slidesOffsetAfter: 10, 
          centeredSlides: false,
          watchOverflow: true,
          navigation: rubbitPrevEl && rubbitNextEl ? {
            prevEl: rubbitPrevEl,
            nextEl: rubbitNextEl,
          } : undefined,
          breakpoints: {
            990: {
              slidesPerView: 2.9,
              spaceBetween: 10,
              slidesOffsetAfter: 23, 
            },
          },
        });
      } else {
        // Keep arrows hidden in static mode.
        if (rubbitNav) rubbitNav.style.display = 'none';
        if (rubbitPrevEl) rubbitPrevEl.style.display = 'none';
        if (rubbitNextEl) rubbitNextEl.style.display = 'none';
        // No slider mode: use static layout styles from CSS.
        rubbitInActionEl.classList.add('rubbit-in-action-slider--static');
      }
    }
    

    // ----------------------------
    // VIDEO PLAY / PAUSE HANDLING
    // ----------------------------
    function toggleThumbnailPlayIconByMediaId(mediaId, isPlaying) {
      if (!mediaId) return;
      const thumbnails = container.querySelectorAll('.new-product-block__thumbnail');
      thumbnails.forEach((thumb) => {
        if (thumb.getAttribute('data-media-id') !== mediaId) return;
        const playIcon = thumb.querySelector('.new-product-block__play-icon');
        if (playIcon) {
          playIcon.style.display = isPlaying ? 'none' : 'flex';
        }
      });
    }

    // Main gallery videos (desktop + mobile): hide thumbnail play icon while playing.
    const mainGalleryVideos = container.querySelectorAll(
      '.new-product-block__main-image-item video, .new-product-block__main-image-slide video'
    );
    mainGalleryVideos.forEach((video) => {
      if (video.dataset.npbMainVideoBound === '1') return;
      video.dataset.npbMainVideoBound = '1';

      const mediaSlide = video.closest('[data-media-id]');
      const mediaId = mediaSlide ? mediaSlide.getAttribute('data-media-id') : '';
      if (!mediaId) return;

      video.addEventListener('play', function () {
        toggleThumbnailPlayIconByMediaId(mediaId, true);
      });

      video.addEventListener('pause', function () {
        toggleThumbnailPlayIconByMediaId(mediaId, false);
      });

      video.addEventListener('ended', function () {
        toggleThumbnailPlayIconByMediaId(mediaId, false);
      });

      // Ensure correct initial state on init/re-init.
      toggleThumbnailPlayIconByMediaId(mediaId, !video.paused && !video.ended);
    });

    const shouldForcePosterReload = window.innerWidth >= 990;
    function resetRubbitReviewVideo(videoEl) {
      if (!videoEl) return;
      videoEl.pause();
      videoEl.currentTime = 0;
      // On mobile, avoid video.load() because it can trigger compositor flicker while scrolling.
      if (shouldForcePosterReload) {
        try { videoEl.load(); } catch (e) {}
      }
    }

    const slides = container.querySelectorAll(".rubbit-video-slide");
    slides.forEach((slide) => {
      // Avoid binding multiple times (initGallery re-runs on resize)
      if (slide.dataset.rubbitVideoBound === "1") return;
      slide.dataset.rubbitVideoBound = "1";

      const video = slide.querySelector("video");
      const playBtn = slide.querySelector(".play_button");

      if (!video || !playBtn) return;

      // Play video on play-button click
      playBtn.addEventListener("click", function () {
        // Pause all other videos
        container.querySelectorAll(".rubbit-video-slide video").forEach((v) => {
          if (v !== video) {
            resetRubbitReviewVideo(v);

            const otherPlayBtn = v.closest(".rubbit-video-slide")?.querySelector(".play_button");
            if (otherPlayBtn) {
              otherPlayBtn.style.display = "flex";
            }
          }
        });

        playBtn.style.display = "none";
        video.play();
      });

      // Pause on clicking the video
      video.addEventListener("click", function () {
        if (!video.paused) {
          resetRubbitReviewVideo(video);
          playBtn.style.display = "flex";
        }
      });

      // When video ends, show button again
      video.addEventListener("ended", function () {
        playBtn.style.display = "flex";
        resetRubbitReviewVideo(video);
      });
    });
  }

  // Make compatible with theme's async Swiper loader (theme.liquid calls window.initializeSwipers on Swiper load)
  const previousInitializeSwipers = window.initializeSwipers;
  window.initializeSwipers = function () {
    if (typeof previousInitializeSwipers === 'function') {
      try { previousInitializeSwipers(); } catch (e) {}
    }
    initGallery();
  };

  // Init (works even if this file loads after DOMContentLoaded)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    initGallery();
  }

  // Re-init on resize
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initGallery, 250);
  });

  // Shopify theme editor / dynamic section reload support
  document.addEventListener('shopify:section:load', initGallery);
  document.addEventListener('shopify:section:select', initGallery);

  // ----------------------------
  // ACCORDION FUNCTIONALITY
  // ----------------------------
  function initAccordion() {
    const container = document.querySelector('.new-product-block');
    if (!container) return;
  
    const buttons = container.querySelectorAll('.new-product-block__accordion-button');

    function openAccordion(button) {
      const panel = button.nextElementSibling;
      const content = panel?.querySelector('.new-product-block__accordion-content');
      if (!panel || !content) return;

      button.classList.add('active');
      button.setAttribute('aria-expanded', 'true');
      panel.style.maxHeight = content.scrollHeight + 'px';
      panel.setAttribute('aria-hidden', 'false');
    }

    // If there is only one accordion item, open it by default.
    if (buttons.length === 1) {
      openAccordion(buttons[0]);
    }
  
    buttons.forEach((button) => {
      const panel = button.nextElementSibling;
      const content = panel?.querySelector('.new-product-block__accordion-content');
      if (!panel || !content) return;
  
      button.addEventListener('click', () => {
        const isOpen = button.classList.contains('active');
  
        buttons.forEach((btn) => {
          const p = btn.nextElementSibling;
          if (!p) return;
  
          btn.classList.remove('active');
          btn.setAttribute('aria-expanded', 'false');
          p.style.maxHeight = '0px';
          p.setAttribute('aria-hidden', 'true');
        });
  
        if (!isOpen) {
          openAccordion(button);
        }
      });
    });
  }
  
  document.addEventListener('DOMContentLoaded', initAccordion);

  // ----------------------------
  // ADD-ON PRODUCT CART FUNCTIONALITY
  // ----------------------------
  function initAddonCart() {
    const container = document.querySelector('.new-product-block');
    if (!container) return;

    const addToCartForm = container.querySelector('#product-form');
    const addToCartButton = container.querySelector('[data-rubbit-add-to-cart]');
    const addonToggle = container.querySelector('.new-product-block__addon-toggle-input');

    if (!addToCartForm || !addToCartButton) return;  

    // Prevent duplicate bindings if this script is executed multiple times
    if (addToCartForm.dataset.npbAddonCartBound === '1') return;
    addToCartForm.dataset.npbAddonCartBound = '1';

    function createNpbLinkId() {
      return 'npb_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
    }

    // Intercept form submission
    addToCartForm.addEventListener('submit', function(e) {
      e.preventDefault();

      // Prevent double-submit while request is running
      if (addToCartForm.dataset.npbSubmitting === '1') return;
      addToCartForm.dataset.npbSubmitting = '1';

      const mainVariantId = addToCartForm.querySelector('input[name="id"]').value;
      const items = [];

      // Always add main product
      const npbLinkId = (addonToggle && addonToggle.checked) ? createNpbLinkId() : null;

      items.push({
        id: mainVariantId,
        quantity: 1,
        properties: npbLinkId ? {
          _npb_link_id: npbLinkId,
          _npb_link_role: 'main'
        } : undefined
      });

      // Add addon product if toggle is enabled
      if (addonToggle && addonToggle.checked) {
        const addonVariantId = addonToggle.getAttribute('data-addon-variant-id');
        if (addonVariantId) {
          items.push({
            id: addonVariantId,
            quantity: 1,
            properties: npbLinkId ? {
              _npb_link_id: npbLinkId,
              _npb_link_role: 'addon'
            } : undefined
          });
        }
      }

      // Disable button during request
      const originalButtonText = addToCartButton.innerHTML;
      if (addToCartButton.dataset.npbRestoreTimer) {
        clearTimeout(Number(addToCartButton.dataset.npbRestoreTimer));
        addToCartButton.dataset.npbRestoreTimer = '';
      }
      addToCartButton.disabled = true;
      addToCartButton.innerHTML = 'Adding...';

      // Add items to cart using Shopify Cart API
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: items
        })
      })
      .then(response => response.json())
      .then(data => {
        // Success - show once, then restore once
        addToCartButton.innerHTML = 'Added to Cart';
        const t = setTimeout(() => {
          addToCartButton.innerHTML = originalButtonText;
          addToCartButton.dataset.npbRestoreTimer = '';
        }, 900);
        addToCartButton.dataset.npbRestoreTimer = String(t);
        
        // Update cart + open cart drawer (cart-handler.js exposes window.updateCart + window.openCartDrawer)
        fetch('/cart.js')
          .then(r => r.json())
          .then(cartData => {
            if (typeof window.updateCart === 'function') {
              window.updateCart(cartData);
            }
            if (typeof window.openCartDrawer === 'function') {
              window.openCartDrawer();
            } else if (typeof window.theme !== 'undefined' && window.theme.cartDrawer) {
              window.theme.cartDrawer.open();
            }
          })
          .catch(() => {
            // Fallback: try opening drawer anyway
            if (typeof window.openCartDrawer === 'function') {
              window.openCartDrawer();
            } else if (typeof window.theme !== 'undefined' && window.theme.cartDrawer) {
              window.theme.cartDrawer.open();
            }
          });
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        addToCartButton.innerHTML = 'Error - Try Again';
        addToCartButton.disabled = false;
        
        setTimeout(() => {
          addToCartButton.innerHTML = originalButtonText;
        }, 2000);
      })
      .finally(() => {
        addToCartForm.dataset.npbSubmitting = '0';
        // Re-enable button
        addToCartButton.disabled = false;
      });
    });
  }

  // Initialize addon cart functionality
  document.addEventListener('DOMContentLoaded', initAddonCart);

  // ----------------------------
  // UPDATE BUY NOW BUTTON PRICE AND HANDLE CLICK
  // ----------------------------
  function initBuyNowPrice() {
    const container = document.querySelector('.new-product-block');
    if (!container) return;

    const buyNowButtons = Array.from(container.querySelectorAll('[data-bfcm-buy-now]'));
    const addonToggle = container.querySelector('.new-product-block__addon-toggle-input');
    const productForm = container.querySelector('#product-form');
    
    if (!buyNowButtons.length) return;

    // Prevent duplicate bindings if this script is executed multiple times
    if (container.dataset.npbBuyNowBound === '1') return;
    container.dataset.npbBuyNowBound = '1';

    function createNpbLinkId() {
      return 'npb_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
    }

    const mainProductPrice = parseInt(buyNowButtons[0].getAttribute('data-main-product-price')) || 0;
    const addonProductPrice = parseInt(buyNowButtons[0].getAttribute('data-addon-product-price')) || 0;

    function formatPrice(cents) {
      return (cents / 100).toFixed(2);
    }

    function formatMoney(cents) {
      const dollars = formatPrice(cents);
      return '$' + dollars;
    }

    function setBuyNowLabel(btn, totalPrice) {
      if (btn.classList.contains('disabled') || btn.disabled) {
        btn.textContent = 'SOLD OUT';
        return;
      }

      // Sticky CTA button supports compare-at display (optional)
      if (btn.hasAttribute('data-npb-sticky-buy-now')) {
        const compareAt = parseInt(btn.getAttribute('data-compare-at-price')) || 0;
        const compareHtml = compareAt && compareAt > totalPrice
          ? ' <s class="npb-sticky-cta__btn-compare">' + formatMoney(compareAt) + '</s>'
          : '';
        btn.innerHTML =
          'BUY NOW - <span class="npb-sticky-cta__btn-price">' +
          formatMoney(totalPrice) +
          '</span>' +
          compareHtml;
      } else {
        btn.textContent = 'BUY NOW - ' + formatMoney(totalPrice);
      }
    }

    function updateBuyNowPrice() {
      let totalPrice = mainProductPrice;
      if (addonToggle && addonToggle.checked && addonProductPrice > 0) {
        totalPrice = mainProductPrice + addonProductPrice;
      }
      buyNowButtons.forEach((btn) => setBuyNowLabel(btn, totalPrice));
    }

    // Handle Buy Now button click
    function handleBuyNowClick(e) {
      e.preventDefault();
      
      const clickedButton = e.currentTarget;
      if (!clickedButton || clickedButton.disabled || clickedButton.classList.contains('disabled')) {
        return;
      }

      if (container.dataset.npbBuyNowSubmitting === '1') return;
      container.dataset.npbBuyNowSubmitting = '1';

      const mainVariantId = productForm ? productForm.querySelector('input[name="id"]').value : null;
      if (!mainVariantId) {
        console.error('Main variant ID not found');
        return;
      }

      const items = [];
      
      // Always add main product
      const npbLinkId = (addonToggle && addonToggle.checked) ? createNpbLinkId() : null;

      items.push({
        id: mainVariantId,
        quantity: 1,
        properties: npbLinkId ? {
          _npb_link_id: npbLinkId,
          _npb_link_role: 'main'
        } : undefined
      });

      // Add addon product if toggle is enabled
      if (addonToggle && addonToggle.checked) {
        const addonVariantId = addonToggle.getAttribute('data-addon-variant-id');
        if (addonVariantId) {
          items.push({
            id: addonVariantId,
            quantity: 1,
            properties: npbLinkId ? {
              _npb_link_id: npbLinkId,
              _npb_link_role: 'addon'
            } : undefined
          });
        }
      }

      // Set loading state
      buyNowButtons.forEach((btn) => {
        btn.disabled = true;
        btn.style.opacity = '0.6';
        btn.style.cursor = 'not-allowed';
        btn.textContent = 'Processing...';
      });

      // Add to cart and redirect to checkout
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }
        return response.json();
      })
      .then(data => {
        // Show success state briefly before redirect
        buyNowButtons.forEach((btn) => {
          btn.textContent = 'Redirecting...';
        });
        setTimeout(() => {
          window.location.href = '/checkout';
        }, 500);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        
        // Show error state
        buyNowButtons.forEach((btn) => {
          btn.textContent = 'Error - Try Again';
          btn.style.opacity = '1';
        });
        
        // Reset button state after 3 seconds
        setTimeout(() => {
          buyNowButtons.forEach((btn) => {
            btn.disabled = false;
            btn.style.opacity = '1';
            btn.style.cursor = 'pointer';
          });
          updateBuyNowPrice();
        }, 3000);
      })
      .finally(() => {
        container.dataset.npbBuyNowSubmitting = '0';
      });
    }

    buyNowButtons.forEach((btn) => {
      btn.addEventListener('click', handleBuyNowClick);
    });

    // Update price on toggle change
    if (addonToggle) {
      addonToggle.addEventListener('change', updateBuyNowPrice);
    }

    // Initial price update
    updateBuyNowPrice();
  }

  document.addEventListener('DOMContentLoaded', initBuyNowPrice);

  // ----------------------------
  // STICKY CTA VISIBILITY (only when .new-product-block is NOT in viewport)
  // ----------------------------
  function initStickyCtaVisibility() {
    const container = document.querySelector('.new-product-block');
    if (!container) return;

    const sticky = container.querySelector('[data-npb-sticky-cta]');
    if (!sticky) return;
    const stickySpacer = container.querySelector('.npb-sticky-cta-spacer');

    // 👇 Use your custom visibility target
    const visibilityTarget =
      container.querySelector('.new-product-block__right .info-wrapper') || container;

    if (sticky.dataset.npbStickyBound === '1') return;
    sticky.dataset.npbStickyBound = '1';

    let isVisible = null;
    let visibilityTimer = null;

    function setVisible(visible) {
      const next = !!visible;
      if (next === isVisible) return;
      isVisible = next;
      sticky.classList.toggle('is-visible', next);
      // Keep spacer in sync to avoid stale gap when sticky hides.
      if (stickySpacer) {
        stickySpacer.style.height = next ? (Math.ceil(sticky.getBoundingClientRect().height) + 'px') : '0px';
      }
    }

    function queueVisible(visible) {
      if (visibilityTimer) clearTimeout(visibilityTimer);
      visibilityTimer = setTimeout(() => {
        setVisible(visible);
        visibilityTimer = null;
      }, 70);
    }

    // Start hidden
    setVisible(false);

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          const entry = entries && entries[0];
          if (!entry) return;

          // ✅ If target is in viewport → hide sticky
          // ✅ If target is NOT in viewport → show sticky
          queueVisible(!entry.isIntersecting);
        },
        {
          root: null,
          threshold: 0.01,
        }
      );

      io.observe(visibilityTarget);
      return;
    }

    // Fallback
    function check() {
      const rect = visibilityTarget.getBoundingClientRect();
      const inViewport =
        rect.top < window.innerHeight && rect.bottom > 0;

      queueVisible(!inViewport);
    }

    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', () => {
      check();
      if (isVisible && stickySpacer) {
        stickySpacer.style.height = Math.ceil(sticky.getBoundingClientRect().height) + 'px';
      }
    });
  }


  document.addEventListener('DOMContentLoaded', initStickyCtaVisibility);

  // ----------------------------
  // SHOW MORE / SHOW LESS ITEMS FUNCTIONALITY
  // ----------------------------
  function initShowMoreItems() {
    const container = document.querySelector('.new-product-block');
    if (!container) return;

    const seeMoreLink = container.querySelector('[data-see-more-link]');
    const showLessLink = container.querySelector('[data-show-less-link]');
    const hiddenItems = container.querySelectorAll('.epremium-kit__item-hidden');
    
    if (hiddenItems.length === 0) return;

    // Show More click handler
    if (seeMoreLink) {
      seeMoreLink.addEventListener('click', function(e) {
        e.preventDefault();
        
        hiddenItems.forEach(function(item) {
          item.classList.remove('epremium-kit__item-hidden');
        });
        
        seeMoreLink.style.display = 'none';
        if (showLessLink) {
          showLessLink.style.display = 'inline-block';
        }
      });
    }

    // Show Less click handler
    if (showLessLink) {
      showLessLink.addEventListener('click', function(e) {
        e.preventDefault();
        
        hiddenItems.forEach(function(item) {
          item.classList.add('epremium-kit__item-hidden');
        });
        
        showLessLink.style.display = 'none';
        if (seeMoreLink) {
          seeMoreLink.style.display = 'inline-block';
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', initShowMoreItems);
})();
